import HighlightService from "@/services/HighlightService";
import StreamService from "@/services/StreamService";
import { sortStreams } from "../../utils";
const defaultState = () => ({
  highlight: null,
  rawhighlight: null,
  sortBy: "Newest",
  isLoading: false,
  isLoaded: false,
});

const state = defaultState();

const mutations = {
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  GET_HIGHLIGHT(state, highlight) {
    state.rawhighlight = highlight;
    state.highlight = highlight;
    state.isLoaded = true;
    state.isLoading = false;
  },
  SET_SORT_OPTION(state, option) {
    state.sortBy = option;
  },
  SEARCH_HIGHLIGHT(state, searchStr) {
    state.highlight = state.rawhighlight;
    state.highlight = state.highlight.filter((s) => {
      const search = searchStr.toLowerCase();
      let bool = s.name.toLowerCase().includes(search);
      return bool;
    });
  },
};

const actions = {
  async getHighlight({ commit, state }, forceRefresh = false) {
    if (state.isLoaded && !forceRefresh) {
      commit("GET_HIGHLIGHT", state.rawhighlight);
      return state.rawhighlight;
    }

    if (state.isLoading) {
      return new Promise((resolve) => {
        const checkLoading = setInterval(() => {
          if (!state.isLoading) {
            clearInterval(checkLoading);
            resolve(state.rawhighlight);
          }
        }, 50);
      });
    }

    commit("SET_LOADING", true);
    try {
      const highlight = await HighlightService.getHighlight();
      commit("GET_HIGHLIGHT", highlight);
      return highlight;
    } catch (error) {
      commit("SET_LOADING", false);
      throw error;
    }
  },
  async setSortOption({ commit }, option) {
    commit("SET_SORT_OPTION", option);
  },
  async searchHighlight({ commit }, searchStr) {
    commit("SEARCH_HIGHLIGHT", searchStr);
  },
};

const getters = {
  rawHighlight: (state) => state.rawhighlight,
  highlight: (state) => {
    const h = state.highlight;
    if (!h) return h;
    const withCreationTime = h.map((item) => ({
      ...item,
      creationTime: item.creationTime || item.createdAt || item._id,
    }));
    return sortStreams(withCreationTime, state.sortBy) || withCreationTime;
  },
  isLoaded: (state) => state.isLoaded,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
